import { UserWorkoutSession } from 'fitbeat.gym-core';
import { UserProfile } from 'fitbeat.models';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import FontAwesomeIcon from 'react-native-vector-icons/Feather';
import { build } from '../../../src';
import { shareOpenInviteLink } from '../../../src/Bookings/utils';
import {Button, ButtonSize, ButtonTypes, Icon } from '../../components';
import { GymResolver } from '../../services';
import Theme from '../../theme';
import { getMomentFormat, isWeb } from '../../utils';
import { createBookingServiceClient } from '../../utils/apiClientFactory';
import { getGymTimezone } from '../../utils/gyms';
import { getOpenInviteLink } from '../../utils/inviteHelper';
import { defaultScale } from '../../utils/scaling';
import AddToCalendarButtons from './AddToCalendarButtons';

interface IProps {
  workoutSession: UserWorkoutSession;
  theme: 'dark' | 'light';
  userProfile: UserProfile;
  t(key: string, options?: any): string;
}

export const WorkoutBookedMessage = ({ t, workoutSession, theme = 'dark', userProfile }: IProps) => {
  const share = async () => {
    const openInviteLink = await getOpenInviteLink(workoutSession);
    await shareOpenInviteLink(t, openInviteLink, userProfile, new Date(workoutSession.startTimeOfFirstExercise));
  };
  const shouldShowShareInviteButton =
    (UserWorkoutSession.isHomeGroupBooking(workoutSession, GymResolver.getByName)) && !isWeb();

  return (
    <View style={styles.container}>
      <View style={styles.contentContainer}>
        <Icon
          size={defaultScale(80)}
          name='ios-checkmark-circle-outline'
          color={Theme.GREEN}
        />
        <Text style={[styles.title, { color: theme === 'light' ? Theme.CHARCOAL : Theme.WHITE }]}>
          {t('bookings:bookingComplete', { context: GymResolver.getByName(workoutSession.gymName).type })}
        </Text>
        <Text style={[styles.date, { color: theme === 'light' ? Theme.CHARCOAL : Theme.WHITE }]}>
          {getMomentFormat(
            workoutSession.startTimeOfFirstExercise,
            'HH:mm dddd, Do MMMM',
            getGymTimezone(workoutSession),
          )}
        </Text>
      </View>

      {shouldShowShareInviteButton &&
        <Button
          title={t('shareInvite')}
          fontColor={Theme.WHITE}
          size={ButtonSize.MEDIUM}
          buttonType={ButtonTypes.NORMAL}
          onPress={share}
          fontSize={defaultScale(17)}
          containerStyle={{ marginBottom: defaultScale(5), width: '100%' }}
          icon=
            {<FontAwesomeIcon name='share' size={defaultScale(20)} color={Theme.WHITE} style={{ paddingRight: 10 }} />}
        />
      }
      {!build.variant.isElite && (<AddToCalendarButtons
        t={t}
        workoutSession={workoutSession}
      />) }
    </View >
  );
};

const styles = StyleSheet.create({
  container: {
    height: '100%',
  },
  contentContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  title: {
    ...Theme.textStyle.heading,
    fontSize: defaultScale(35),
    textAlign: 'center',
  },
  date: {
    ...Theme.textStyle.bodyCopyReg,
    paddingVertical: defaultScale(10),
  },
  saveToCalendar: {
    ...Theme.textStyle.heading,
    paddingBottom: defaultScale(20),
    textAlign: 'center',
  },
  addToCalendarContainer: {
    width: '100%',
    padding: defaultScale(20),
    marginTop: defaultScale(50),
    borderRadius: defaultScale(5),
    borderWidth: 0.5,
  },
});
